import { useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import * as S from "./styled";
//Components
import LayoutModal from "../../../LayoutModal";
import Search from "../../../Search";
//hooks
import apiRequest from "../../../../hooks/apiRequest";
import useLoading from '../../../../hooks/useLoading';
//Interface
import { Inputs } from "Interfaces/ICancel";
import { ICreate } from "Interfaces/ICreate";
import { IOrder } from "Interfaces/IOrder";
//utils
import { CurrencyFormat } from "utils/CurrencyFormat";
import FormatarData from "utils/FormatData";
//icons
import { FlagBanner, ReceiptX } from "@phosphor-icons/react";

export default function CreateCancell({
  isOpenModal,
  setModalClose,
  refreshFrames,
  setToastData,
  setToastOpen
}: ICreate) {
  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm<Inputs>();

  const { isLoading, startLoading, stopLoading } = useLoading();
  const [dataSale, setDataSale] = useState<IOrder | null>(null);

  const reasonsForms = [
    { reason: 'Cliente desistiu da compra', id: 'reason-1' },
    { reason: 'Produto indisponível', id: 'reason-2' },
    { reason: 'Erro no preço/desconto', id: 'reason-3' },
    { reason: 'Problema no pagamento', id: 'reason-4' },
    { reason: 'Erro do operador', id: 'reason-5' },
    { reason: 'Solicitação do cliente', id: 'reason-6' },
    { reason: 'Outros', id: 'reason-7' },
  ];

  const flagsForms = [
    {
      title: 'Bandeira Vermelha',
      flag: 'red',
      reason: 'Cliente apresentou problemas graves (Evitar futuras vendas).',
      status: 'error',
    }, {
      title: 'Bandeira Laranja',
      flag: 'orange',
      reason: 'Cliente apresentou alguns problemas (Requer atenção).',
      status: 'warning',
    }, {
      title: 'Sem Restrição',
      flag: 'green',
      reason: 'Cliente não apresentou problemas durante a transação.',
      status: 'sucess',
    },
  ];

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    startLoading();
    try {
      const payload = {
        ...data,
        sale_id: dataSale ? dataSale?.id : null,
      }

      const response = await apiRequest('cancellation', 'POST', payload);
      if (response.status === 201) {
        setToastData({
          status: response.status,
          message: 'Cadastrado com sucesso!',
        });

        setToastOpen(true);
        refreshFrames();
        onClose();

      }
    } catch (error: any) {
      setToastData({
        status: error?.response?.status || 500,
        message: error.message || 'Erro inesperado',
      });

      setToastOpen(true);
    } finally {
      stopLoading();
    }
  };

  const onClose = () => {
    setDataSale(null);
    setModalClose();
    reset();
  };

  const handleSaleSelect = (product: IOrder) => {
    if (product) {
      setDataSale(product);
    }
  }

  if (isOpenModal) {
    return (
      <LayoutModal
        statusLoad={isLoading}
        title="Cancelamento da Venda"
        subTitle="Preencha os dados para cancelar a venda."
        setModalClose={onClose}
        submiteModal={handleSubmit(onSubmit)}

        nameIconMinimize={'Registrar Cancelamento'}
      >
        <S.Container>
          <Search
            label="Número da venda"
            placeholder="Busque o número da venda"
            url="sale?number_ata="
            idSelect={handleSaleSelect}
          />
          {
            dataSale &&
            <S.ContentInfor>
              <S.Icons>
                <ReceiptX size={24} />
              </S.Icons>
              <div>
                <S.InforDescription className="title">Número da venda #{dataSale.number_ata || '-'}</S.InforDescription>
                <S.InforDescription>Data: {FormatarData(dataSale.date_sale, 'default') || '-'}</S.InforDescription>
                <S.InforDescription>Total: {CurrencyFormat(parseFloat(dataSale.total_amount || '0'))}</S.InforDescription>
                <S.InforDescription>Cliente: {dataSale.customer?.full_name || '-'}</S.InforDescription>
                <S.InforDescription>Vendedor: {dataSale.user?.first_name || '-'}</S.InforDescription>
              </div>
            </S.ContentInfor>
          }

          <S.Section>
            <S.Title>
              Motivo do Cancelamento
              <span>*</span>
            </S.Title>
            {
              reasonsForms.map((reason, index) =>
                <S.ContentInput>
                  <S.Input
                    {...register('reason', { required: true })}
                    type="radio"
                    id={`reason-${index}`}
                    name="reason"
                    value={reason.reason}
                  />
                  <S.Label
                    htmlFor={`reason-${index}`}
                    className="infor"
                  >
                    {reason.reason}
                  </S.Label>
                </S.ContentInput>
              )
            }
            {errors.flag && <S.InforErro>Campo Obrigatório</S.InforErro>}
          </S.Section>

          <S.FormInput>
            <S.SectionHighlight>
              <S.Title>
                Bandeira do Cliente <span>*</span>
              </S.Title>

              {flagsForms.map((flag, index) => (
                <S.ContentHighlight key={index}>
                  <S.Input
                    {...register("flag", { required: true })}
                    type="radio"
                    id={`flag-${index}`}
                    name="flag"
                    value={flag.flag}
                  />
                  <S.Label htmlFor={`flag-${index}`} className={flag.status}>
                    <FlagBanner size={14} weight="fill" />
                    {flag.title}
                  </S.Label>
                  <S.InforDescription>{flag.reason}</S.InforDescription>
                </S.ContentHighlight>
              ))}
            </S.SectionHighlight>

            {errors.flag && <S.InforErro>Campo Obrigatório</S.InforErro>}
          </S.FormInput>


          <S.FormInput>
            <S.Label>Observações adicionais</S.Label>
            <S.TextArea
              {...register('observation')}
              placeholder="Descreva detalhes adicionais sobre o cancelamento..."
              rows={2}
            />
          </S.FormInput>
        </S.Container>
      </LayoutModal >
    );
  }
  return null;
}
